/**
 * 중국어(간체). 다국어표(`HERIT_UI_다국어.docx`)에 있는 키는 표 그대로.
 * 표에 없는 키는 구현자 번역 — 각 항목에 `// TODO 검수` 표시, 고객 검수 후 확정.
 */
export const COPY_ZH = {
    "common.back": "返回", // TODO 검수
    "common.brandCaption": "韩国之美，属于我的一张", // TODO 검수
    "common.home": "返回首页",
    "common.keepGoing": "继续",
    "common.homeConfirmTitle": "要返回首页吗？",
    "common.homeConfirmBody": "目前的进度将会丢失。",
    "idle.title": "您还在吗？",
    "idle.body": "{sec}秒内无操作将返回首页",
    "common.brandTag": "韩国文化拍照亭", // TODO 검수
    "journey.theme": "选择主题",
    "journey.style": "选择风格",
    "journey.capture": "拍摄",
    "journey.result": "查看结果",
    "journey.receive": "领取照片",
    "attract.tagline": "韩国文化 AI 拍照亭",
    "attract.headline": "走进韩国之美\n定格属于你的瞬间",
    "attract.cta": "开始",
    "themeSelect.title": "请选择主题",
    "themeSelect.count": "{n} 种主题", // TODO 검수
    "themeSelect.cta": "选择",
    "themeSelect.storiesLabel": "收录的故事",
    "styleSelect.back": "重新选择主题", // TODO 검수
    "styleSelect.title": "请挑选风格",
    "styleSelect.cta": "选择这个风格",
    "styleSelect.next": "下一个风格", // TODO 검수
    // consent
    "consent.title": "拍照前\n需要您的同意", // TODO 검수
    "consent.required": "必须", // TODO 검수
    "consent.view": "查看", // TODO 검수
    "consent.close": "关闭", // TODO 검수
    "consent.allAgree": "全部同意", // TODO 검수
    "consent.processor": "个人信息处理者：{name}", // TODO 검수
    "consent.contact": "联系方式：{contact}", // TODO 검수
    "consent.refusal": "不同意则无法使用拍照服务", // TODO 검수
    "consent.cta": "同意", // TODO 검수
    "consent.decline": "不同意", // TODO 검수
    "consent.back": "返回风格选择", // TODO 검수
    "preview.back": "重新挑选风格", // TODO 검수
    "preview.title": "请看镜头",
    "preview.tip1": "请正面看向镜头，让脸部清晰可见。", // TODO 검수
    "preview.tip2": "按下拍摄按钮后 {sec} 秒自动拍照。", // TODO 검수
    "preview.tip3": "不满意可以重拍。", // TODO 검수
    "preview.placeholderTitle": "请站到镜头前", // TODO 검수
    "preview.placeholderBody": "正在连接摄像头。\n首次使用请允许摄像头权限。", // TODO 검수
    "preview.connecting": "正在连接摄像头…", // TODO 검수
    "preview.shoot": "拍照",
    "preview.openCamera": "打开摄像头", // TODO 검수
    "preview.closeCamera": "返回提示", // TODO 검수
    "preview.cancel": "取消拍摄", // TODO 검수
    "preview.retry": "重新连接摄像头", // TODO 검수
    "preview.note": "拍摄的照片仅用于 AI 转换。", // TODO 검수
    "preview.holdStill": "请保持不动", // TODO 검수
    "preview.confirmTitle": "用这张照片继续吗？", // TODO 검수
    "preview.confirmHint": "如果闭眼或模糊，请重拍。", // TODO 검수
    "preview.confirmRetake": "重拍", // TODO 검수
    "preview.confirmProceed": "继续", // TODO 검수
    "preview.errorTitle": "无法使用摄像头", // TODO 검수
    "preview.errorTitleNoDevice": "未找到摄像头", // TODO 검수
    "preview.errorPermissionDenied": "摄像头权限已关闭。请在浏览器设置中允许摄像头后重新连接。", // TODO 검수
    "preview.errorNoDevice": "此设备未找到已连接的摄像头。请连接摄像头后重试。", // TODO 검수
    "preview.errorInsecureContext": "仅在 HTTPS 地址下可使用摄像头。", // TODO 검수
    "preview.errorTimeout": "摄像头无响应。请确认没有其他应用正在使用摄像头，然后重新连接。", // TODO 검수
    "preview.errorUnknown": "无法连接摄像头，请重新连接。", // TODO 검수
    "generate.title": "正在生成照片",
    "generate.hint": "大约需要 30 秒",
    "generate.selectedLabel": "SELECTED STYLE",
    "generate.developing": "DEVELOPING",
    "generate.step0": "正在识别脸部", // TODO 검수
    "generate.step1": "正在为您换装", // TODO 검수
    "generate.step2": "正在绘制背景", // TODO 검수
    "generate.step3": "正在添加细节", // TODO 검수
    "generate.remaining": "还需约 {sec} 秒", // TODO 검수
    "generate.almostDone": "快完成了", // TODO 검수
    "generate.queueWait": "排队人数较多，请稍候", // TODO 검수
    "generate.tookTooLong": "耗时较长", // TODO 검수
    "generate.failed": "转换失败", // TODO 검수
    "generate.cancel": "取消", // TODO 검수
    "generate.retry": "重试", // TODO 검수
    "generate.proceed": "继续", // TODO 검수
    "generate.back": "返回拍摄", // TODO 검수
    "review.title": "完成",
    "review.retake": "重拍",
    "review.next": "领取照片",
    "review.makeVideo": "✨ 同时生成视频", // TODO 검수
    "review.makeVideoPriced": "✨ 同时生成视频 · +{price}", // TODO 검수
    "review.slotError": "转换失败", // TODO 검수
    "videoIntro.back": "返回结果", // TODO 검수
    "videoIntro.title": "动态写真", // TODO 검수
    "videoIntro.body": "5 秒竖版视频。\n保存到手机即可立即发布。", // TODO 검수
    "videoIntro.cta": "制作", // TODO 검수
    "videoIntro.skip": "只要照片", // TODO 검수
    "videoMotions.back": "返回结果", // TODO 검수
    "videoMotions.title": "请选择动作", // TODO 검수
    "videoMotions.subtitle": "最多两个 · 按您选择的顺序衔接", // TODO 검수
    "videoMotions.hint": "请至少选择一个动作", // TODO 검수
    "videoMotions.next": "下一步", // TODO 검수
    "videoCaption.back": "返回", // TODO 검수
    "videoCaption.title": "留下一句话吗？", // TODO 검수
    "videoCaption.subtitle": "将作为字幕出现在视频中", // TODO 검수
    "videoCaption.placeholder": "最多12个字", // TODO 검수
    "videoCaption.preset1": "济州，今天", // TODO 검수
    "videoCaption.preset2": "风带来的一天", // TODO 검수
    "videoCaption.preset3": "愿我们长久", // TODO 검수
    "videoCaption.preset4": "只有好事", // TODO 검수
    "videoCaption.next": "下一步", // TODO 검수
    "videoCaption.skip": "不添加", // TODO 검수
    "videoGenerate.back": "返回结果", // TODO 검수
    "videoGenerate.title": "正在开始制作视频", // TODO 검수
    "videoGenerate.caption": "请稍候", // TODO 검수
    "videoGenerate.error": "视频生成失败", // TODO 검수
    "videoGenerate.retry": "重试", // TODO 검수
    "videoGenerate.skipToPhoto": "仅领取照片", // TODO 검수
    "videoGenerate.refunded": "视频费用将自动退回到您的支付方式。", // TODO 검수
    "payment.title": "支付", // TODO 검수
    "payment.cancel": "取消", // TODO 검수
    "payment.kicker": "SCAN TO PAY",
    "payment.itemPhoto": "照片打印 1张", // TODO 검수
    "payment.itemVideo": "动态写真 5秒", // TODO 검수
    "payment.total": "合计", // TODO 검수
    "payment.qrHeading": "请用手机支付", // TODO 검수
    "payment.qrHint": "请用手机相机扫描二维码", // TODO 검수
    "payment.methods": "KakaoPay · NaverPay · TossPay · 银行卡", // TODO 검수
    "payment.noticeVideo": "确认付款后开始制作视频。\n付款前不会制作。", // TODO 검수
    "payment.noticePhoto": "确认付款后即可领取照片。", // TODO 검수
    "payment.remaining": "剩余 {time}", // TODO 검수
    "payment.wifiHint": "手机没有网络时请使用店内Wi-Fi。", // TODO 검수
    "payment.connectionLost": "正在检查连接。付款完成后将自动继续。", // TODO 검수
    "payment.failedHint": "付款未完成。请在手机上重试。", // TODO 검수
    "payment.unavailable": "目前无法支付。\n请呼叫工作人员。", // TODO 검수
    "payment.createError": "无法准备支付。请重试。", // TODO 검수
    "payment.expired": "支付已超时。请重新进行。", // TODO 검수
    "payment.closed": "支付已取消。请重新进行。", // TODO 검수
    "printShare.title": "请领取您的照片",
    "printShare.kicker": "SCAN TO SAVE",
    "printShare.qrHeading": "保存到手机",
    "printShare.desc1": "扫描 QR 码即可保存",
    "printShare.desc2": "链接在{days}天内有效",
    "printShare.privacy": "原始照片于转换后立即删除 · 生成照片{days}天后删除",
    "printShare.printCta": "打印",
    "printShare.retake": "重拍",
    "printShare.home": "返回首页",
    "printShare.doneCta": "完成", // TODO 검수
    "printShare.shareHint": "点击打印后，请在分享菜单中选择“打印”", // TODO 검수
    "printShare.bodyWithVideo": "扫描 QR 码可同时领取照片和视频。", // TODO 검수
    "printShare.bodyVideoPending": "照片现在就能领取，视频约 2 分钟后\n会出现在同一链接中", // TODO 검수
    "printShare.bodyVideoFailed": "视频未能生成。\n照片仍可正常领取。", // TODO 검수
    "printShare.videoPendingLabel": "制作中", // TODO 검수
    "printShare.photoLabel": "照片", // TODO 검수
    "printShare.videoLabel": "视频", // TODO 검수
    "printShare.uploading": "上传", // TODO 검수
    "printShare.uploadError": "上传失败，请重试。", // TODO 검수
    "printShare.retry": "重试", // TODO 검수
    "printShare.qrAlt": "照片领取页面 QR 码", // TODO 검수
    "printShare.agentOffline": "正在检查打印机连接，打印可能会延迟", // TODO 검수
    "thanks.title": "谢谢", // TODO 검수
    "thanks.body": "已为您留下美好瞬间 · {sec} 秒后返回首页", // TODO 검수
    "thanks.tapHint": "触摸屏幕立即返回", // TODO 검수
    "lock.title": "当前无法使用", // TODO 검수
    "lock.body": "Currently Unavailable",
    "print.title": "正在打印…",
    "print.sub": "请记得取走您的照片",
    "print.status": "PRINTING · 1 / 1 · 约18秒",
    "print.preparing": "正在准备打印…", // TODO 검수
    "print.delayed": "打印有所延迟。\n请呼叫工作人员", // TODO 검수
    "print.delayedHint": "照片可通过二维码获取", // TODO 검수
    "print.failed": "打印失败。\n请呼叫工作人员", // TODO 검수
    "print.paperOut": "打印纸已用完。\n请呼叫工作人员", // TODO 검수
};
//# sourceMappingURL=zh.js.map